module.exports = __webpack_public_path__ + "img/eye_close.cab7ea8e.svg";